/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from '@/store/modules/user'

import {
    getCustomerNameListByFinanceBackMoneyMainPart,
    getOrderListOrMarketCoopetationId,
    setFinanceInvoice,
    getFinanceInvoiceDetailTemplate,
    importFinanceInvoiceDetail,
    getCompanyList,
    getFinanceInvoiceContent
} from '@/api/financial-center'

import { menuBtn } from '@/utils/menu_level2_button'

import { delNullProperty } from "@/utils";
import * as math from "mathjs";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class MakeInvoiceAdd extends Vue {
    invoiceNumTitle = '订单/回款编号：'  //订单回款编号label
    changeMoneyData: []  //开票明细输入本次开票金额
    customerId: number  //客户id
    customerType: string  //客户类型
    marketCooperationId: number  //合作伙伴id
    select = '1'  //回款编号
    options = [
        { label: '客户名称', value: '0' },
        { label: '订单/回款编号', value: '1' },
    ]
    thisTimePrice = null//本次开票金额
    logList = []
    tableRandom = Math.random()
    customerNameOrMarketCooperationName = ''
    formDataMarket = {
        account: '',
        address: '',
        bank: '',
        code: '',
        phone: '',
        title: '',
        types: '',
        invoiceContent: '', //开票内容
        email:'' ,// 发票接收邮箱
        titleTypes:'' ,// 抬头类型
    }
    formOptions = new Array(0)
    tableInvoiceData = [] //开票明细列表
    invoiceStatus = ''
    // backMoneyAccountOptions = ['苏州', '北京', '广州', '上海']   //收款账户
    backMoneyAccountOptions = []   //收款账户
    studentDialog = false
    partnerDialog = false
    studentDialogInputValue = ''
    partnerDialogInputValue = ''
    studentDialogTaleData = []
    partnerDialogTaleData = []
    studentDialogTotal = 0
    partnerDialogTotal = 0
    studentDialogPage = 1
    partnerDialogPage = 1
    studentDialogTableLoading = false
    partnerDialogTableLoading = false
    tablePartnerData = []
    tableData = []
    receivableConfirmList = {
        financeBackMoneyCode: '',
        directorUserRealName: '',
        financeBackMoneyId: '',
        financeBackMoneyPrice: '',
        financeInvoiceDetailList: [],
        mainPartName: '',
        price: '',
        surplusInvoicePrice: '',
    }
    partnerDialogSelect = {
        customerId: null, //客户id
        customerType: '',  //客户类型
        marketCooperationId: null,  //合作伙伴id
        customerName: '',   //学生客户名字
        marketCooperationName: '',//合作伙伴名字
        invoiceInfo: null,
        invoiceContent: '',
    }
    parnterConfirmList  = {
        customerId: null, //客户id
        customerType: '',  //客户类型
        marketCooperationId: null,  //合作伙伴id
        customerName: '',   //学生客户名字
        marketCooperationName: '',//合作伙伴名字
        invoiceInfo: null
    }
    studentDialogSelect = {
        customerId: null, //客户id
        customerType: '',  //客户类型
        marketCooperationId: null,  //合作伙伴id
        customerName: '',   //学生客户名字
        marketCooperationName: '',//合作伙伴名字
        invoiceInfo: null
    }
    studentConfirmList = {
        customerId: null, //客户id
        customerType: '',  //客户类型
        marketCooperationId: null,  //合作伙伴id
        customerName: '',   //学生客户名字
        marketCooperationName: '',//合作伙伴名字
        invoiceInfo: null
    }
    orderDialog = false  //学生订单列表
    partnersOrderDialog = false  //合作伙伴订单列表
    receivableDialog = false
    orderDialogInputValue = ''
    receivableDialogInputValue = ''
    orderDialogTaleData = []
    receivableDialogTaleData = []
    orderDialogTotal = 0
    receivableDialogTotal = 0
    orderDialogPage = 1
    receivableDialogPage = 1
    orderDialogTableLoading = false
    receivableDialogTableLoading = false
    orderDialogSelectTable = []
    // orderDialogSelectTable = {
    //     financeOrderCode: '',  //订单编号
    //     financeBackMoneyCode: '', //回款编号
    //     financeInvoiceDetailList: [],
    //     surplusInvoicePrice: '', //可回款金额
    //     // customerId: null, //客户id
    //     code: '',  //订单/回款编号
    // }
    receivableDialogSelectTable = {
        financeBackMoneyCode: '',
        directorUserRealName: '',
        financeBackMoneyId: '',
        financeBackMoneyPrice: '',
        financeInvoiceDetailList: [],
        mainPartName: '',
        price: '',
        surplusInvoicePrice: '',
        companyName: ''
    }

    formData = {
        thisTimePrice: null,
        financeBackMoneyPrice: null,
        mainPart: '',  //开票主体
        invoiceBodyName: '', //主体名称
        basis: '', //开票依据
        isProof: '', //是否生成凭证
        remark: '',
        code: '',  //订单回款编号
        account: '',
        studentName: '',
        studentContract: '',
        agencyContract: '',
        date: new Date(),
        directorUserId: UserModule.userId || '',
        deparment: '',
        deparmentId: NaN,
        surplusInvoicePrice: null,
        directorUserName: null,
    }
    fileList = []
    fileList1 = []
    disabledButton = false
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'
    backMoneyId: number = null
    orderId: number = null
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 草稿id
    backMoneyStatus = ''
    file = []
    fileData = null
    readyOption = true
    pagesize = 20
    timer = null
    timernew = null
    timerNew1 = null
    partnertimer = null
    // isReadonly = false
    makeInvoiceContent = [
        // {label:'课程服务费',value:'0'},
        // {label:'教育服务培训费',value:'1'},
        // {label:'培训费',value:'2'},
        // {label:'培训服务费',value:'3'},
        // {label:'教育咨询服务费',value:'4'}
    ]
    chioceBackMoneyloading = false
    titleTypesoptions = [
        {label: '企业单位', value: '0'},
        {label: '个人/非企业单位', value: '1'}
    ]
    loading = false

    private validType: any = (rule, value, callback) => {
        if (value === "" && !value) {
            this.$message.error('开票信息不完整，请补充')
            callback(new Error('开票信息不完整，请补充'))
        } else {
            callback();
        }
    }

    formRules = {
        // mainPart: [{ validator: this.validType, message: '请选择开票主体', trigger: 'change' }],
        mainPart: [{ required: true, message: '请选择开票主体', trigger: 'change' }],
        invoiceBodyName: [{ required: true, message: '请选择主体名称', trigger: 'change' }],
        basis: [{ required: true, message: '请选择开票依据', trigger: 'change' }],
        // code: [{ required: true, message: '请选择订单/回款编号', trigger: 'change' }],
        remark: [{ validator: this.validType, message: '请输入备注', trigger: 'blur' }],
        account: [{ required: true, message: '请选择收款账户', trigger: 'change' }],
        isProof: [{ required: true, message: '请选择是否生成凭证', trigger: 'change' }],
        directorUserId: [{ required: true, message: '请选择负责人', trigger: 'change' }],
    }
    formRule = {
        titleTypes: [{ required: true, message: '请选择抬头类型', trigger: ['change']}],
        types: [{ required: true, message: '请选择开票类型', trigger: 'change' }],
        title: [{ required: true, message: '请输入开票抬头', trigger: 'blur' }],
        code: [{ required: true, message: '请输入纳税识别号', trigger: 'blur' }],
        bank: [{ required: true, message: '请输入开户行', trigger: ['blur','change'] }],
        account: [{ required: true, message: '请输入开户账号', trigger: ['blur','change'] }],
        address: [{ required: true, message: '请输入开票地址', trigger: ['blur','change'] }],
        phone: [{ required: true, message: '请输入电话', trigger: ['blur','change'] }],
        invoiceContent: [{ required: true, message: '请选择开票内容', trigger: 'change' }],
        email: [{ required: true, message: '请输入发票接收邮箱', trigger: 'blur' }],
    }
    get userName() {
        return UserModule.userName
    }

    get department() {
        return UserModule.department
    }

    get directorUserId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        this.tableInvoiceData.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(item.thisTimePrice ? item.thisTimePrice : 0)))
        })
        return num
    }


    menuBtn = menuBtn

    created(){
        this.getCompanyList()
    }

    changeDirectorUser(e) {
        this.formData.directorUserId = e.id
        if (e.id) {
            this.formData.deparment = e.departmentName
        }
    }


    changeTitleTypes(val) {
        this.formDataMarket.types = ''
    }

    getFinanceInvoiceContent() {
        if (this.formData.account) {
            this.makeInvoiceContent = []
            getFinanceInvoiceContent({
                companyName: this.formData.account
            }).then((res: any) => {
                res.financeInvoiceContent.forEach((item) => {
                    this.makeInvoiceContent.push({
                        label: item.content,
                        value: item.types,
                    })
                })
            })
        } else {
            this.$message.error('请选择收款账户')
        }
    }

    // 明细删除
    clickDelOrder(row) {
        this.tableInvoiceData = this.tableInvoiceData.filter((item =>
                item.financeOrderId !== row.financeOrderId
        ))
        if (this.tableInvoiceData && this.tableInvoiceData.length > 0) {
            let num = 0
            this.tableInvoiceData.forEach(item => {
                // 订单金额 - 已开票金额
                const val = math.number(math.subtract(math.bignumber(item.financeOrderPrice), math.bignumber(item.financeInvoicePrice)))
                num = math.number(math.add(math.bignumber(num), math.bignumber(val)))
            })
            this.formData.financeBackMoneyPrice = num
        }else {
            this.formData.financeBackMoneyPrice = 0
        }
    }

    // 开票明细导出
    exportExcelData(res) {
        require.ensure([], () => {
            const { export_json_to_excel } = require('../../../../vender/Export2Excel.js')
            const tHeader = ['订单编号','学生名称','项目名称','项目类型','开课时间','已开票金额','订单金额','回款金额','本次开票金额']
            const filterVal =  ['financeOrderCode','customerName','souCourseName','souCourseType','souCourseSchoolBegin','financeInvoicePrice','financeOrderPrice','financeBackMoneyPrice','thisTimePrice']
            const list = this.tableInvoiceData
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, '开票明细')
        })
    }

    // 开票账户
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.backMoneyAccountOptions = data.companyList
        this.backMoneyAccountOptions.forEach(item => {
            if (item.name == '北京集思互联教育科技有限公司' || item.name == '上海恒艾教育科技有限公司' || item.name == '北京昌意科技有限公司'||  item.name == '天津集思互动教育咨询有限公司'|| item.name == '蒸汽松鼠（北京）科技有限公司'|| item.name == '青岛集思互动教育咨询有限公司'|| item.name == '北京汉文清雅文化有限公司') {
                item.disabled = false
            } else {
                item.disabled = true
            }
        })
    }

    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    }

    // 选择订单可回款金额为0禁止选择
    selectOrder(row) {
        if (row.surplusInvoicePrice > 0) {
            return true  //可勾选
        } else {
            return false  //不可勾选
        }
    }
    // 选择回款可回款金额为0禁止选择
    selectReceivable(row) {
        if (row.surplusInvoicePrice > 0) {
            return true  //可勾选
        } else {
            return false  //不可勾选
        }
    }
    // 订单/回款列表change
    handleChangeOrderCode(val) {
        this.select = val
    }
    // 开票主体选中值
    handleChangeInvoice(val) {
        this.formData.invoiceBodyName = ''
        this.formData.basis = ''
        this.formData.code = ''
        this.tableInvoiceData = []
        this.formDataMarket.title = ''
        this.formDataMarket.code = ''
        this.formDataMarket.bank = ''
        this.formDataMarket.account = ''
        this.formDataMarket.address = ''
        this.formDataMarket.phone = ''
        this.formDataMarket.types = ''
        this.formDataMarket.email = ''
        this.formData.financeBackMoneyPrice = ''
        this.formData.mainPart = val
        this.invoiceNumTitle = '订单/回款编号'
        this.customerNameOrMarketCooperationName = ''
        if(val == 0){
            this.studentDialogPage = 1
        }
        if (val == 1) {
            this.partnerDialogPage = 1
            // 抬头默认为企业
            this.formDataMarket.titleTypes = '0'
        }
    }
    // 主体名称列表
    choiceStudent(e) {
        // this.studentDialogInputValue = ''
        // this.partnerDialogInputValue = ''
        if (this.formData.mainPart === '') {
            this.$message.error('请选择开票主体')
            return
        }
        if (this.formData.mainPart === '0') {
            this.studentDialogPage = 1
            this.studentDialogInputValue = ''
            this.studentDialog = true
        }
        if (this.formData.mainPart === '1') {
            this.partnerDialogPage = 1
            this.partnerDialogInputValue = ''
            this.partnerDialog = true
        }
        this.customerNameOrMarketCooperationName = ''
        this.getCustomerNameListByFinanceBackMoneyMainPart()
        e.target.blur()
    }
    // 合作伙伴、学生列表
    async getCustomerNameListByFinanceBackMoneyMainPart() {
        if (this.formData.mainPart == '0') {
            this.studentDialogTableLoading = true

        }
        if (this.formData.mainPart == '1') {
            this.partnerDialogTableLoading = true

        }
        const obj = {
            customerNameOrMarketCooperationName:this.customerNameOrMarketCooperationName,
            mainPart: this.formData.mainPart,
            page: this.formData.mainPart == '0' ? this.studentDialogPage : this.partnerDialogPage,
            limit: 20
        }
        const data: any = await getCustomerNameListByFinanceBackMoneyMainPart(delNullProperty(obj))

        if (this.formData.mainPart == '0') {
            this.studentDialogTaleData = data.customerOrMarketCooperationList
            this.studentDialogTotal = data.allNum
            this.studentDialogTableLoading = false
            // this.isReadonly = false
        }
        if (this.formData.mainPart == '1') {
            this.partnerDialogTaleData = data.customerOrMarketCooperationList
            // this.partnerDialogTaleData = [...this.partnerDialogTaleData, ...data.customerOrMarketCooperationList]
            this.partnerDialogTotal = data.allNum
            this.partnerDialogTableLoading = false
            // this.isReadonly = false
        }
        this.tableRandom = Math.random()
    }
    // 学生列表取消
    handleStudentDialog(){
        const id = this.studentConfirmList.customerId != this.studentDialogSelect.customerId
        const type = this.studentConfirmList.customerType != this.studentDialogSelect.customerType
        if(!this.studentConfirmList || ( id&&type )){
            const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            studentTable.clearSelection()
            studentTable.toggleRowSelection(this.studentConfirmList,true)
        }
        if(this.studentConfirmList){
            const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            studentTable.toggleRowSelection(this.studentConfirmList,true)
        }
        this.studentDialog = false
    }
    // 学生列表确定事件  0-学生, 1-合作伙伴
    studentDialogConfirm() {
        this.studentConfirmList = this.studentDialogSelect  //存数据取消选中状态
        this.formData.invoiceBodyName = ''
        this.formData.basis = ''
        this.formData.code = ''
        this.tableInvoiceData = []
        this.formDataMarket.title = ''
        this.formDataMarket.code = ''
        this.formDataMarket.bank = ''
        this.formDataMarket.account = ''
        this.formDataMarket.address = ''
        this.formDataMarket.phone = ''
        this.formDataMarket.types = ''
        this.formDataMarket.email = ''
        this.formData.financeBackMoneyPrice = ''
        if (this.formData.mainPart == '0') {
            this.formData.invoiceBodyName = this.studentDialogSelect.customerName
            this.customerId = this.studentDialogSelect.customerId
            this.customerType = this.studentDialogSelect.customerType
        }
        this.studentDialog = false
        this.studentDialogInputValue = ''
        this.tableData = []
    }
    // 合作伙伴列表取消
    handleParnterDialog(){
        if(!this.parnterConfirmList || (this.parnterConfirmList.marketCooperationId != this.partnerDialogSelect.marketCooperationId)){
            const parnterTable = this.$refs.partnerDialogTable as HTMLFormElement
            parnterTable.clearSelection()
            parnterTable.toggleRowSelection(this.parnterConfirmList,true)
        }
        if(this.partnerDialogSelect){
            const parnterTable = this.$refs.partnerDialogTable as HTMLFormElement
            parnterTable.toggleRowSelection(this.partnerDialogSelect,true)
        }
        this.partnerDialog = false
    }
    // 合作伙伴、列表确定事件  0-学生, 1-合作伙伴
    partnerDialogConfirm() {
        this.parnterConfirmList = this.partnerDialogSelect  //存数据取消选中状态
        this.formData.invoiceBodyName = ''
        this.formData.basis = ''
        this.formData.code = ''
        this.tableInvoiceData = []
        this.formDataMarket.title = ''
        this.formDataMarket.code = ''
        this.formDataMarket.bank = ''
        this.formDataMarket.account = ''
        this.formDataMarket.address = ''
        this.formDataMarket.phone = ''
        this.formDataMarket.types = ''
        this.formDataMarket.invoiceContent = '' // 开票内容
        this.formDataMarket.email = ''
        this.formData.financeBackMoneyPrice = ''
        if (this.formData.mainPart == '1') {
            this.marketCooperationId = this.partnerDialogSelect.marketCooperationId
            this.formData.invoiceBodyName = this.partnerDialogSelect.marketCooperationName
        }
        this.formDataMarket = { ...this.partnerDialogSelect.invoiceInfo }
        this.formDataMarket.types = this.formDataMarket.types === '增值税专用发票' ? '0' : '1'
        this.formDataMarket.titleTypes = this.formDataMarket.titleTypes === '企业单位' ? '0' : '1'
        this.partnerDialog = false
        this.partnerDialogInputValue = ''
        this.tablePartnerData = []
        this.invoiceNumTitle = '订单/回款编号'
    }
    getRowKeys (row) {
        return `${row.customerId}${row.customerType}`
    }
    // 学生列表搜索
    async clickStudentDialogFilter() {
        if (this.timernew !== null) clearTimeout(this.timernew)
        this.timernew = setTimeout(() => {
            this.studentDialogPage = 1
            this.customerNameOrMarketCooperationName = this.studentDialogInputValue
            this.getCustomerNameListByFinanceBackMoneyMainPart()
        }, 1000)
        // this.studentDialogTableLoading = true
        // let obj = {
        //     mainPart: this.formData.mainPart,
        //     page: this.studentDialogPage,
        //     customerNameOrMarketCooperationName:this.studentDialogInputValue,
        //     limit: this.studentDialogTotal
        // }

        // const data: any = await getCustomerNameListByFinanceBackMoneyMainPart(delNullProperty(obj))
        // this.studentDialogTaleData = data.customerOrMarketCooperationList
        // this.studentDialogTotal = data.allNum
        // this.studentDialogTableLoading = false
        // this.tableRandom = Math.random()
        // this.studentDialogTaleData = data.customerList.filter(item => item.customerName.includes(this.studentDialogInputValue))
    }
    // 合作伙伴、列表搜索
    async clickPartnerDialogFilter(page: number) {
        if (this.partnertimer !== null) clearTimeout(this.partnertimer)
        this.partnertimer = setTimeout(() => {
            this.partnerDialogPage = page
            this.customerNameOrMarketCooperationName = this.partnerDialogInputValue
            this.getCustomerNameListByFinanceBackMoneyMainPart()
            // this.partnerDialogTableLoading = true
            // const data: any = await getCustomerNameListByFinanceBackMoneyMainPart({ mainPart: this.formData.mainPart, page: this.partnerDialogPage, limit: this.partnerDialogTotal })
            // this.partnerDialogTaleData = data.customerList.filter(item => item.marketCooperationName.includes(this.partnerDialogInputValue))
            // this.partnerDialogTableLoading = false
        }, 1000)
    }
    // 合作伙伴、学生列表change
    studentDialogSelectionChange(selectionArr: any[]) {
        if (selectionArr.length > 0) {
            this.studentDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if (selectionArr.length > 1) {
                const studentTableToggle = this.$refs.studentDialogTable as HTMLFormElement
                studentTableToggle.clearSelection()
                studentTableToggle.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.studentDialogSelect) {
                this.studentDialogSelect[key] = null
            }
        }
    }
    partnerDialogSelectionChange(selectionArr: any[]) {
        if (selectionArr.length > 0) {
            this.partnerDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if (this.partnerDialogSelect.invoiceInfo) {
                this.partnerDialogSelect.invoiceInfo.invoiceContent = ''
            }
            if (selectionArr.length > 1) {
                const customerTable = this.$refs.partnerDialogTable as HTMLFormElement
                customerTable.clearSelection()
                customerTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.partnerDialogSelect) {
                this.partnerDialogSelect[key] = null
                // if (key == 'invoiceInfo') {
                //     this.partnerDialogSelect[key] = {}
                // }
            }
        }
    }
    studentDialogPageChange(page: number) {
        this.studentDialogPage = page
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    pageSizeChange(limit: number) {
        this.studentDialogTotal = limit
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    partnerDialogPageChange(page: number) {
        this.partnerDialogPage = page
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    partnerPageSizeChange(limit: number) {
        this.partnerDialogTotal = limit
        this.getCustomerNameListByFinanceBackMoneyMainPart()
    }
    // 订单、回款编号列表
    choiceCode(e) {
        if(!this.formData.mainPart){
            this.$message.error('请选择开票主体')
            return
        }
        if(!this.formData.invoiceBodyName){
            this.$message.error('请选择主体名称')
            return
        }
        if(!this.formData.basis){
            this.$message.error('请选择开票依据')
            return
        }
        if (this.formData.basis == '0') {
            this.orderDialog = true
        }
        if (this.formData.basis == '1') {  //回款
            this.receivableDialog = true
        }
        this.orderDialogPage = 1
        this.getOrderListOrMarketCoopetationId()
        e.target.blur()
    }
    //  订单、回款编号列表
    async getOrderListOrMarketCoopetationId() {
        const obj = {
            mainPart: this.formData.mainPart,  //开票主体 允许值: 0-学生, 1-合作伙伴
            page: this.formData.basis == '0' ? this.orderDialogPage : this.receivableDialogPage,
            limit: this.pagesize,
            basis: this.formData.basis,   //开票依据 允许值: 0-订单编号, 1-回款编号
            customerId: this.formData.mainPart == '0' ? Number(this.customerId) : Number(''), //客户id // 当mainPart = 0时必需
            customerType: this.formData.mainPart == '0' ? String(this.customerType) : '',  //客户类型 // 当mainPart = 0时必需 允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
            marketCooperationId: this.formData.mainPart == '1' ? Number(this.marketCooperationId) : Number(''),  //合作伙伴id // 当mainPart = 1时必需
            code: this.select == '订单/回款编号' ? this.orderDialogInputValue : '',   //订单/回款编号
        }
        // for (const key in obj) {
        //     if (obj[key].length === 0 || !obj[key]) {
        //         delete obj[key]
        //     }
        // }
        this.chioceBackMoneyloading = true
        await getOrderListOrMarketCoopetationId(delNullProperty(obj)).then((data: any)=>{
        if (this.formData.basis == '0') {
            this.orderDialogTaleData = data.resultList
            this.orderDialogTaleData.forEach(item => {
                if(this.tableInvoiceData.findIndex(item1=>item1.financeOrderId===item.financeOrderId)>-1) {
                    const studentTable = this.$refs.orderDialogTable as HTMLFormElement
                    studentTable.toggleRowSelection(item,true)
                }
            })
            this.orderDialogTotal = data.allNum
            this.orderDialogTableLoading = false
        }
        if (this.formData.basis == '1') {
            this.receivableDialogTaleData = data.resultList
            this.receivableDialogTotal = data.allNum
            this.receivableDialogTableLoading = false
            this.chioceBackMoneyloading = false
        }
        }).catch(err=>{
            this.chioceBackMoneyloading = false
        })
    }
    handleChangeBasis(val) {
        this.formData.thisTimePrice = null
        this.formData.code = ''
        this.tableInvoiceData = []
        this.formData.financeBackMoneyPrice = ''
        this.formData.basis = val
        this.invoiceNumTitle = val == 0?'订单编号：':val == 1?'回款编号：': '订单/回款编号：'
        this.formData.account = ''
    }
    handleChangeType(val) {
        this.formDataMarket.types = val
    }
    handleChangeTypes(val) {
        this.formDataMarket.bank = val
    }
    // 开票内容change
    handleChangeContent(val) {
        this.formDataMarket.invoiceContent = val
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.orderDialogPage = page
            this.clickOrderDialogFilter()
        }, 1000)
    }

    // 订单编号列表搜索
    async clickOrderDialogFilter() {
        this.orderDialogPage = 1
        this.orderDialogTableLoading = true

        const obj = {
            mainPart: this.formData.mainPart,   //开票主体 允许值: 0-学生, 1-合作伙伴
            page: this.orderDialogPage,
            limit: this.pagesize,
            basis: this.formData.basis,   //开票依据 允许值: 0-订单编号, 1-回款编号
            customerId: this.formData.mainPart == '0' ? Number(this.customerId) : Number(''),  //客户id // 当mainPart = 0时必需
            customerType: this.formData.mainPart == '0' ? String(this.customerType) : '',   //客户类型 // 当mainPart = 0时必需 允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
            marketCooperationId: this.formData.mainPart == '1' ? Number(this.marketCooperationId) : Number(''),   //合作伙伴id // 当mainPart = 1时必需
            code: this.select == '1' ? this.orderDialogInputValue : '',   //订单/回款编号
            customerName:this.select == '0' ? this.orderDialogInputValue : '', // 客户名称
        }
        for (const key in obj) {
            if (obj[key] == '' || !obj[key]) {
                delete obj[key]
            }
        }
        const data: any = await getOrderListOrMarketCoopetationId(obj)
        this.orderDialogTaleData = data.resultList
        this.orderDialogTotal = data.allNum
        this.orderDialogTableLoading = false
        // this.isReadonly = false

    }
   //
    pageReceivableChange(page: number) {
        if (this.timerNew1 !== null) clearTimeout(this.timerNew1)
        this.timerNew1 = setTimeout(() => {
            this.receivableDialogPage = page
            this.clickReceivableDialogFilter()
        }, 1000)
    }


    // 回款编号列表搜索
    async clickReceivableDialogFilter() {
        this.receivableDialogPage = 1
        // this.receivableDialogTableLoading = true

        const obj = {
            mainPart: this.formData.mainPart,   //开票主体 允许值: 0-学生, 1-合作伙伴
            page: this.receivableDialogPage,
            limit: 20,
            basis: this.formData.basis,   //开票依据 允许值: 0-订单编号, 1-回款编号
            customerId: this.formData.mainPart == '0' ? Number(this.customerId) : Number(''),  //客户id // 当mainPart = 0时必需
            customerType: this.formData.mainPart == '0' ? String(this.customerType) : '',   //客户类型 // 当mainPart = 0时必需 允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
            marketCooperationId: this.formData.mainPart == '1' ? Number(this.marketCooperationId) : Number(''),   //合作伙伴id // 当mainPart = 1时必需
            code: this.receivableDialogInputValue ,   //订单/回款编号

        }
        // for (const key in obj) {
        //     if (obj[key] == '' || !obj[key]) {
        //         delete obj[key]
        //     }
        // }
        this.chioceBackMoneyloading = true
        const data: any = await getOrderListOrMarketCoopetationId(delNullProperty(obj))

        this.receivableDialogTaleData = data.resultList

        this.receivableDialogTableLoading = false
        this.chioceBackMoneyloading = false
        // this.isReadonly = false
    }
    handleChangeIsProof(val) { //是否上传凭证
        this.formData.isProof = val
    }
    // 订单列表取消
    handleOrderDialog(){
        this.orderDialogSelectTable.map(item => {
            this.tableInvoiceData.map(items => {
                if(item.financeOrderId !== items.financeOrderId){
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if(this.tableInvoiceData.length > 0){
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableInvoiceData.forEach(row => {
                orderDialogTable.toggleRowSelection(row,true)
            });
        }else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialogInputValue = ''
        this.orderDialog = false
    }
    // 订单确认事件
    orderDialogConfirm() {
        let num = 0
        this.orderDialogSelectTable.map(
            item => {

                const list = item.financeInvoiceDetailList[0]
                const val = math.number(math.subtract(math.bignumber(list.financeOrderPrice), math.bignumber(list.financeInvoicePrice)))
                num = math.number(math.add(math.bignumber(num), math.bignumber(val)))
            }
        )

        this.formData.financeBackMoneyPrice = num   //可开票金额

        this.tableInvoiceData = []
        this.orderDialogSelectTable.map(item => {
            const Index = this.tableInvoiceData.findIndex((items) => {return items.financeOrderId === item.financeOrderId})
            if(Index == -1){
                item.financeInvoiceDetailList.map(listItem => {
                    this.tableInvoiceData.push({
                        ...item,
                        customerName: listItem.customerName,
                        souCourseName: listItem.souCourseName,
                        souCourseType: listItem.souCourseType,
                        souCourseSchoolBegin: listItem.souCourseSchoolBegin,
                        financeInvoicePrice: listItem.financeInvoicePrice,
                        financeBackMoneyPrice: listItem.financeBackMoneyPrice,
                        thisTimePrice: item.thisTimePrice ? item.thisTimePrice : 0,

                    })
                })

            }

        })
        this.formData.account = this.tableInvoiceData[0].companyName
        this.getFinanceInvoiceContent() // 获取开票内容
        this.formDataMarket.invoiceContent = ''

        const studentTable = this.$refs.orderDialogTable as HTMLFormElement
        studentTable.clearSelection()
        this.orderDialogInputValue =''
        this.orderDialog = false
    }
    // 回款列表取消
    handleReceivableDialog(){
        if(!this.receivableConfirmList || (this.receivableConfirmList.financeBackMoneyId != this.receivableDialogSelectTable.financeBackMoneyId)){
            const receivableTable = this.$refs.receivableDialogTable as HTMLFormElement
            receivableTable.clearSelection()
            receivableTable.toggleRowSelection(this.receivableConfirmList,true)
        }
        if(this.receivableDialogSelectTable){
            const receivableTable = this.$refs.receivableDialogTable as HTMLFormElement
            receivableTable.toggleRowSelection(this.receivableDialogSelectTable,true)
        }
        this.receivableDialogInputValue = ''
        this.receivableDialog = false
    }
    // 选择回款
    receivableDialogConfirm() {
        if (this.formData.basis == '1') {
            this.formData.code = this.receivableDialogSelectTable.financeBackMoneyCode   //回款编号1
        }
        this.receivableConfirmList = this.receivableDialogSelectTable  //存数据取消选中状态
        if (this.receivableDialogSelectTable.financeInvoiceDetailList) {
            const arr = this.receivableDialogSelectTable.financeInvoiceDetailList
            let allAlreadyMaceInvoice = 0
            let allOrderAmount = 0
            let allThisAmount = 0
            this.tableInvoiceData = arr.map((item, index) => {
                allOrderAmount = math.number(math.add(math.bignumber(allOrderAmount), math.bignumber(Number(item.financeOrderPrice))))
                allAlreadyMaceInvoice = math.number(math.add(math.bignumber(allAlreadyMaceInvoice), math.bignumber(Number(item.financeInvoicePrice))))
                const val = math.number(math.subtract(math.bignumber(item.financeOrderPrice), math.bignumber(item.financeInvoicePrice)))
                allThisAmount = math.number(math.add(math.bignumber(allThisAmount), math.bignumber(val)))
                return Object.assign(item, {thisTimePrice: Number(item.financeOrderPrice) - Number(item.financeInvoicePrice)})
            })
            //    可开票金额
            // this.formData.financeBackMoneyPrice = allOrderAmount - allAlreadyMaceInvoice - allThisAmount
            const val = math.number(math.subtract(math.bignumber(allOrderAmount), math.bignumber(allAlreadyMaceInvoice)))
            this.formData.financeBackMoneyPrice = math.number(math.subtract(math.bignumber(val), math.bignumber(allThisAmount)))
        } else {
            this.tableInvoiceData = []
        }
        this.formData.account =  this.receivableDialogSelectTable.companyName
        this.getFinanceInvoiceContent()
        this.formDataMarket.invoiceContent = ''

        this.receivableDialogInputValue = ''
        this.receivableDialog = false
        // this.orderCodeValue = ''
    }
    handleReceivableClick(row) {
        if (row.surplusInvoicePrice > 0) {//可勾选
            (this.$refs.receivableDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }
    handleStudentRowClick(row) {
        (this.$refs.studentDialogTable as HTMLFormElement).toggleRowSelection(row)
    }
    handlePartnerClick(row) {
        (this.$refs.partnerDialogTable as HTMLFormElement).toggleRowSelection(row)
    }
    // 订单列表change
    orderDialogSelectionChange(selectionArr: any[]) {
        // 订单如果主体为合作伙伴可以多选 学生单选
        if(this.formData.mainPart == '0'){  //学生
            if(selectionArr.length > 0){
                this.orderDialogSelectTable = selectionArr
                if(selectionArr.length > 1){
                    const orderTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderTable.clearSelection()
                    orderTable.toggleRowSelection(selectionArr.pop()) //pop() 方法用于删除并返回数组的最后一个元素。
                }
            }else {
                this.orderDialogSelectTable = []
            }
        }else if (this.formData.mainPart == '1'){  //合作伙伴
            this.orderDialogSelectTable = selectionArr
            if (selectionArr.length > 0) {
                const val = selectionArr[0].companyName
                const flag = selectionArr.every(ele => ele.companyName === val)
                if (!flag) {
                    this.$message.error('所选订单的收款账户不一致')
                }
            }
        }
    }

    // 订单
    handleOrderRowClick(row) {
        if(row.surplusInvoicePrice > 0) { //可勾选
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }
    // orderDialogSelectionChange(selectionArr: any[]) {
    //     this.orderDialogSelectTable = selectionArr
    // }

    receivableDialogSelectionChange(selectionArr: any[]) {
        if (selectionArr.length > 0) {
            this.receivableDialogSelectTable = JSON.parse(JSON.stringify(selectionArr[0]))
            if (selectionArr.length > 1) {
                const receivableTable = this.$refs.receivableDialogTable as HTMLFormElement
                receivableTable.clearSelection()
                receivableTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.receivableDialogSelectTable) {
                this.receivableDialogSelectTable[key] = null
            }
        }
    }
    // orderDialogPageChange(page: number) {
    //     this.orderDialogPage = page
    //     this.getOrderListOrMarketCoopetationId()
    // }
    receivableDialogPageChange(page: number) {
        this.receivableDialogPage = page
    }
    orderDialogTableSelect(row) {
        // return row.selectDisabled && row.needBackMoney !== 0
    }


    // 可开票金额
    get commission_totals() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.priceSum))
        return num
    }
    // 开票明细计算总价
    getSummaries(param: any) {
        const { columns, data } = param;
        const sums: any = [];
        columns.forEach((column: any, index: number) => {
            if (index === 0) {
                sums[index] = '总计';
                // return;
            } else if (index === 7) {
                const values = data.map((item: any) => Number(item[column.property]));
                if (column.property === 'thisTimePrice') {
                    sums[index] = values.reduce((prev: any, curr: any) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return Math.round(((Math.floor(prev * 100) / 100 + Math.floor(curr * 100) / 100) * 100)) / 100;
                        } else {
                            return prev;
                        }
                    }, 0)
                }
            } else {
                sums[index] = '';
            }
        });
        return sums;
    }

    // 学生开票明细(4.8迭代需求废弃)
    thisBackMoneyChange(val) {
        if (this.formData.financeBackMoneyPrice) {
            if (Number(val) > Number(this.formData.financeBackMoneyPrice)) {
                this.$message.error('本次开票金额不能大于可开票金额')
            }
            this.formData.thisTimePrice = val
            this.tableInvoiceData = this.tableInvoiceData.map((item, index) => {
                return Object.assign(item, { thisTimePrice: this.formData.thisTimePrice })
            })
        }

    }

    onExchangeChange(index){
        const tmpObj = this.tableInvoiceData[index];
        this.$set(this.tableInvoiceData, index, tmpObj);
    }
    handleOninput(num,limit) {
        let str = num
        const len1 = str.substr(0, 1)
        const len2 = str.substr(1, 1)
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
            str = str.substr(1, 1)
        }
        //第一位不能是.
        if (len1 == ".") {
            str = ""
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
            const str_ = str.substr(str.indexOf(".") + 1)
            if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
            }
        }
        //正则替换
        str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
        if (limit / 1 === 1) {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/,'$1') // 小数点后只能输 1 位
        } else {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1') // 小数点后只能输 2 位
        }
        return str
    }

    thisMoneyChange(row, val) {
        val = this.handleOninput(val,'2')
        row.thisTimePrice = this.handleOninput(val,'2')

       // 本次开票金额小于等于可开票金额
        let allThisAmount = 0
        let allSurplusAmount = 0
        if (this.formData.basis == '0') {//订单编号0
            this.tableInvoiceData.forEach((item, index) => {

                allThisAmount = math.number(math.add(math.bignumber(allThisAmount), math.bignumber(Number(item.thisTimePrice))))
                allSurplusAmount = math.number(math.add(math.bignumber(allSurplusAmount), math.bignumber(Number(item.surplusInvoicePrice))))

                if (item.financeOrderId === row.financeOrderId) {
                    // 重新赋值
                    if (Number(val) > Number(item.financeOrderPrice)) {
                        this.$message.error('本次开票金额不能大于可开票金额')
                    }
                    const tmpObj = this.tableInvoiceData[index];
                    this.$set(this.tableInvoiceData, index, tmpObj);
                }
            })
            this.formData.financeBackMoneyPrice =math.number(math.subtract( math.bignumber( allSurplusAmount ), math.bignumber(allThisAmount)))

        }
        if (this.formData.basis == '1') {//回款编号1
            const arr = this.receivableDialogSelectTable.financeInvoiceDetailList
            this.tableInvoiceData.forEach((item,index) => {
                if(item.financeOrderId === row.financeOrderId){
                    // 重新赋值
                    if (Number(val) > Number(item.financeOrderPrice)) {
                        this.$message.error('本次开票金额不能大于可开票金额')
                    }
                    const tmpObj = this.tableInvoiceData[index];
                    this.$set(this.tableInvoiceData, index, tmpObj);
                }
            })
            //
            let allOrderMount = 0
            let allAlreadyMakeInvoice = 0
            let allThisMakeInvoice = 0
            this.tableInvoiceData = arr.map((item, index) => {
                allOrderMount = math.number(math.add(math.bignumber(allOrderMount), math.bignumber(Number(item.financeOrderPrice))))
                allAlreadyMakeInvoice = math.number(math.add(math.bignumber(allAlreadyMakeInvoice), math.bignumber(Number(item.financeInvoicePrice))))
                allThisMakeInvoice = math.number(math.add(math.bignumber(allThisMakeInvoice), math.bignumber(Number(item.thisTimePrice))))
                return Object.assign(item, {thisTimePrice: item.thisTimePrice})
            })
            const val = math.number(math.subtract(math.bignumber(allOrderMount), math.bignumber(allAlreadyMakeInvoice)))
            this.formData.financeBackMoneyPrice = math.number(math.subtract(math.bignumber(val), math.bignumber(allThisMakeInvoice)))

        }
    }

    // 收款账户
    handleChangeAccount(val) {
        this.formData.account = val
        this.getFinanceInvoiceContent()
        this.formDataMarket.invoiceContent = ''
    }
    // 新建保存并提交
    clickSubmintButton() {

        // 开票信息 如果有值 保存清空空格
        if (this.formDataMarket.code) {
            this.formDataMarket.code = this.clearBlank(this.formDataMarket.code)
        }
        if (this.formDataMarket.title) {
            this.formDataMarket.title = this.clearBlank(this.formDataMarket.title)
        }
        if (this.formDataMarket.bank) {
            this.formDataMarket.bank = this.clearBlank(this.formDataMarket.bank)
        }
        if (this.formDataMarket.email) {
            this.formDataMarket.email = this.clearBlank(this.formDataMarket.email)
        }
        if (this.formDataMarket.account) {
            this.formDataMarket.account = this.clearBlank(this.formDataMarket.account)
        }
        if (this.formDataMarket.address) {
            this.formDataMarket.address = this.clearBlank(this.formDataMarket.address)
        }
        if (this.formDataMarket.phone) {
            this.formDataMarket.phone = this.clearBlank(this.formDataMarket.phone)
        }

        const obj = {
            mainPart: this.formData.mainPart,  //开票主体 允许值: 0-学生, 1-合作伙伴
            customerId: this.formData.mainPart == '0' ? Number(this.customerId) : Number(''),  //客户id // 当mainPart = 0时必需
            customerType: this.formData.mainPart == '0' ? String(this.customerType) : '',  //客户类型 // 当mainPart = 0时必需  允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
            marketCooperationId: this.formData.mainPart == '1' ? Number(this.marketCooperationId) : Number(''),  //合作伙伴id 当mainPart = 1时必需
            basis: this.formData.basis,  //开票依据 允许值: 0-订单编号, 1-回款编号
            code: this.formData.code,  //订单/回款编号
            account: this.formData.account,  //收款账户 允许值: '苏州', '北京', '广州', '上海'
            isProof: this.formData.isProof,  //是否生成凭证   允许值: 0-否, 1-是
            remark: this.formData.remark,  //备注
            invoiceType: this.formDataMarket.types,  //开票类型 允许值: 0-增值税专用票, 1-普通发票
            titleTypes: this.formDataMarket.titleTypes,  //开票抬头类型
            invoiceTitle: this.formDataMarket.title,  //开票抬头
            invoiceCode: this.formDataMarket.code, //纳税识别号
            invoiceBank: this.formDataMarket.bank,  //开户行
            invoiceAccount: this.formDataMarket.account,   //开户账号
            invoiceAddress: this.formDataMarket.address,   //开票地址
            invoicePhone: this.formDataMarket.phone,   //电话
            invoiceContent: this.formDataMarket.invoiceContent, //开票内容
            invoiceEmail: this.formDataMarket.email, //开票接收邮箱
            directorUserId: this.formData.directorUserId, //负责人id
            financeInvoiceDetailList: []
        }
        //开票详情  订单id  本次开票金额
        for (const key in obj) {
            if (obj[key] == '' || !obj[key]) {
                delete obj[key]
            }
        }
        if (this.tableInvoiceData) {
            this.tableInvoiceData.map(item => {
                if(item.thisTimePrice){
                    item.thisTimePrice = parseFloat(item.thisTimePrice)
                }
            })
            obj.financeInvoiceDetailList = this.tableInvoiceData.map(item => ({

                financeOrderId: item.financeOrderId, thisTimePrice: String(item.thisTimePrice)
            }))

        }
        (this.$refs['formRef'] as HTMLFormElement).validate((valid1: boolean) => {
            (this.$refs['formRefs'] as HTMLFormElement).validate((valid: boolean) => {
                if (valid1 && valid) {
                    if (this.formData.mainPart == '1' && !this.tableInvoiceData.some(item => item.thisTimePrice)) {
                        this.$message.error('请输入本次开票金额')
                        return
                    }

                    // 开票金额不可为空
                    let flag = true
                    this.tableInvoiceData.forEach(item => {
                        if (!item.thisTimePrice) {
                            this.$message.error('本次开票金额不可为空')
                            flag = false
                        }
                    })

                    if (flag) {
                        this.disabledButton = true;
                        this.loading = true
                        setFinanceInvoice(obj).then(() => {
                            this.$message.success('新建成功')
                            this.loading = false
                            setTimeout(() => {
                                this.closePage()
                                this.$router.go(-1)
                            }, 1500)
                            this.saveDraftDialogShow = false

                        }).catch((err: Error) => {
                            if (err) {
                                this.disabledButton = false
                                this.loading=  false
                            }
                            if (err.message === '审批流报错') {
                                this.errorDialogShow = true
                            }
                        })
                    }
                }
            })
        })
    }

    // 存草稿取消
    saveDraftDialogCancel() {
        this.isDraft = '0'
        this.saveDraftDialogShow = false
    }

    closePage() {
        window.close()
    }
    // 下载导入开票模板
    async clickDownload(){
        const data: any = await getFinanceInvoiceDetailTemplate()
        const a: any = document.createElement('a')
        a.href = data.financeInvoiceDetailTemplateUrl //  URL对象
        a.click() // 模拟点击
    }
    // 导入
    handleFileChange(file,fileList) {
        const upload: any = this.$refs.upload
        upload.clearFiles()
        this.file = fileList.slice(-1);
        if(this.file.length > 0){
            this.sureExport()
        }
    }
    async sureExport() {
        const formData = new FormData()
        formData.append('file', this.file[0].raw)
        importFinanceInvoiceDetail(formData).then((res) => {
            const { financeOrderList } = res as unknown as { financeOrderList: any}
            if (financeOrderList.length > 0) {
                const val = financeOrderList[0].companyName
                const flag = financeOrderList.every(ele => ele.companyName === val)
                if (!flag) {
                    this.$message.error('所选订单的收款账户不一致')
                }
                this.formData.account = val
                this.getFinanceInvoiceContent()
            }
            financeOrderList.map(item => {
                this.tableInvoiceData.push({
                    ...item,
                    // thisTimePrice: item.thisTimePrice, //本次开票金额
                })
            })
            this.file = []
            this.fileData = {}
            let num = 0
            this.tableInvoiceData.forEach(item => {
                num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.surplusInvoicePrice ? item.surplusInvoicePrice : 0))))
            })
            this.formData.financeBackMoneyPrice = num   //可开票金额
        }).catch(err => {
            console.log(err)
        })
    }
    handleFile(){
        if (this.formData.mainPart === '' ||  this.formData.invoiceBodyName === ''|| this.formData.basis === '') {
            this.$message.error(`请选择${this.formData.mainPart === '' ? '开票主体' : ''}${this.formData.invoiceBodyName === '' ? '主体名称，' : ''}${this.formData.basis === '' ? '开票依据' : ''}`)
            return
        }else {
            this.readyOption = false
        }
    }

    handleSizeChange(val) {
        this.pagesize = val
        this.getOrderListOrMarketCoopetationId();
    }

    handleCurrentChange(val) {
        this.orderDialogPage = val
        this.getOrderListOrMarketCoopetationId();
    }

    /*去除所有空格*/
    clearBlank(str: string) {
        return str.replace(/\s+/g, '')
    }

    changeCode(val) {
        this.formDataMarket.code = this.clearBlank(val)
    }

    changeTitle(val) {
        this.formDataMarket.title = this.clearBlank(val)
    }

    changeEmail(val) {
        this.formDataMarket.email = this.clearBlank(val)
    }

    changeBank(val) {
        this.formDataMarket.bank = this.clearBlank(val)
    }

    changeAccount(val) {
        this.formDataMarket.account = this.clearBlank(val)
    }

    changeAddress(val) {
        this.formDataMarket.address = this.clearBlank(val)
    }

    changePhone(val) {
        this.formDataMarket.phone = this.clearBlank(val)
    }

    @Watch('directorUserId')
    handle(userId: string) {
        if(!this.formData.directorUserId){
            this.formData.directorUserId = userId
        }
    }

    @Watch('userName')
    handleuserName(userName: string) {
        if(!this.formData.directorUserName){
            this.formData.directorUserName = userName
        }
    }

    @Watch('department')
    handleChangeDepartment(department: string) {
        if (!this.formData.deparment) {
            this.formData.deparment = department
        }
    }


}
